<template>
    <div>
        <b-list-group
            class="mt-2"
        >
            <template
                v-for="student in students"
            >
                <b-list-group-item
                    v-if="studentAttendance[student.id] < attendanceOptions.length"
                    :key="student.id"
                >
                    <b>{{ student.first_name }} {{ student.last_name }}</b>
                    <b-select
                        v-model="studentAttendance[student.id]"
                        :options="attendanceOptions"
                        class="mt-2"
                    ></b-select>
                </b-list-group-item>
            </template>
        </b-list-group>
        <div class="my-2 text-center">
            <button
                class="sc-btn pill"
                @click="setPerfectAttendance()"
            >
                <font-awesome-icon icon="star" class="mr-2"></font-awesome-icon>
                Perfect Attendance
            </button>
            <button
                class="sc-btn pill"
                @click="submitAttendanceSheet()"
            >
                <font-awesome-icon icon="save" class="mr-2"></font-awesome-icon>
                Submit
            </button>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        class_id:        Number,
        students:        Array,
        attendanceSheet: { type: Object, default: () => {} },
        date:            String
    },
    data() {
        // Initialize student attendance
        let studentAttendance = {};
        if (this.attendanceSheet && this.attendanceSheet.id > 0)
            Object.assign(studentAttendance, JSON.parse(this.attendanceSheet.record));
        else
            this.students.forEach((student) => {
                studentAttendance[student.id] = "";
            });
        return {
            attendanceOptions: [{ text: "Present", value: 1 }, { text: "Absent", value: 0 }],
            studentAttendance: studentAttendance
        };
    },
    methods: {
        setPerfectAttendance() {
            this.students.forEach((student) => {
                this.studentAttendance[student.id] = 1;
            });
        },
        submitAttendanceSheet() {
            this.$api.post("/api/teacher/save-attendance-sheet", {
                class_id : this.class_id,
                record   : this.studentAttendance,
                date     : this.date
            }).then(({ data: { success, message } }) => {
                this.$bvToast.toast(message, {
                    title: (success) ? "Success!" : "Error!",
                    variant: (success) ? "success" : "danger",
                    solid: true
                });
                if (success) {
                    this.$emit("saved");
                    this.loadAttendanceSheet();
                }
            });
        }
    }
}
</script>